import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <span className="text-xl font-heading font-semibold text-background-50 whitespace-nowrap">
                掌中美母
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              为现代母亲打造专属美丽养护方案，帮助每一位妈妈在繁忙生活中找回自信光彩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              美丽分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  品牌故事
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              关注我们
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              关注掌中美母微信公众号和小红书账号，获取每日美丽养护小贴士。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="text-xs text-foreground-400 bg-foreground-800 px-3 py-1 rounded-full whitespace-nowrap">
                微信公众号：掌中美母
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; {currentYear} 掌中美母. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;